/*
WHY (Bug 34682):  Kendo MultiSelect 22.x cancels `pointerdown` on its popup to keep focus in the search input.
                  On iPad Safari a cancelled pointerdown also drops the tap's `click`, and Kendo selects list
                  items on `click`, so a tapped name never selects: the field stays empty and red. Confirmed on
                  a real iPad through Ryn Replay (TouchStart, TouchEnd, Blur, no Click on the list item).
                  Kendo 23+ cancels `mousedown` instead (telerik/kendo-angular#4912); this applies the same swap.

REMOVE:           when @progress/kendo-angular-dropdowns is upgraded to 23 or later
                  (together with MultiSelectTouchSelectFixDirective).
 */

/** The two @hidden Kendo MultiSelect internals the fix touches. Both are optional so an upgrade degrades to a no-op. */
export interface MultiSelectPopupInternals {
  popupRef?: { popupElement?: HTMLElement };
  popupPointerDownHandler?: EventListener;
}

const FIXED_FLAG = 'upsTouchSelectFix';

const preventMouseDownDefault = (event: Event) => event.preventDefault();

/**
 * Moves the open popup's focus guard from `pointerdown` to `mousedown`, the way Kendo 23+ does.
 * Returns true when the popup was changed, false when it was already fixed or the internals are absent.
 */
export function applyMultiSelectTouchSelectFix(
  multiSelect: MultiSelectPopupInternals | null | undefined
): boolean {
  const popup = multiSelect?.popupRef?.popupElement;
  const kendoPointerDownHandler = multiSelect?.popupPointerDownHandler;
  if (!popup || !kendoPointerDownHandler || popup.dataset[FIXED_FLAG]) {
    return false;
  }
  popup.removeEventListener('pointerdown', kendoPointerDownHandler);
  popup.addEventListener('mousedown', preventMouseDownDefault);
  popup.dataset[FIXED_FLAG] = 'true';
  return true;
}
